import qs from 'qs'
import request, { ResultHandler, AuthService } from '@/core/utils/request'
const UserBaseUrl = '/admin/user'

export async function queryUser(params) {
  const result = await request({
    url: UserBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query user failed!') ?? []
}

export async function createUser(data) {
  const result = await request({
    url: UserBaseUrl,
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Create user failed!') ?? []
}

export async function updateUser(data) {
  const result = await request({
    url: UserBaseUrl,
    method: 'PUT',
    data
  })
  return ResultHandler(result, 'Update user failed!') ?? []
}

export async function removeUser(id) {
  const result = await request({
    url: UserBaseUrl,
    method: 'DELETE',
    params: { id }
  })
  return ResultHandler(result, 'Delete user failed!') ?? []
}

export async function login(data) {
  const result = await request({
    url: '/admin/login',
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Failed to login!')
}

export async function getUserInfoFromToken(token) {
  const result = await AuthService({
    url: '/users/check',
    method: 'GET',
    params: { token }
  })
  return ResultHandler(result, 'verify user login failed')
}

export async function sendVerificationCode(username) {
  const result = await AuthService({
    url: '/users/code',
    method: 'GET',
    params: { username }
  })
  return result
}
